import { useState, useCallback, useRef, useEffect } from "react";

import EmailLogin from "../components/Email-Login-Form";

import { useLoginSubmit } from "./api";

type SubmitStatus = "not-started" | "submitting" | "complete";

function SignIn() {
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      if (mounted.current) {
        mounted.current = false;
      }
    };
  });

  const [submitStatus, setSubmitStatus] = useState<SubmitStatus>("not-started");
  const [createSuccess, setCreateSuccess] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>();

  const login = useLoginSubmit();

  const resetSubmitStatus = useCallback(() => {
    if (mounted.current) {
      if (submitStatus !== "not-started") {
        setSubmitStatus("not-started");
      }
    }
  }, [submitStatus, setSubmitStatus, mounted.current]);

  return (
    <EmailLogin
      resetPasswordLink="/reset-password"
      createSuccess={createSuccess}
      setCreateSuccess={setCreateSuccess}
      submitStatus={submitStatus}
      setSubmitStatus={setSubmitStatus}
      errorMessage={errorMessage}
      setErrorMessage={setErrorMessage}
      resetSubmitStatus={resetSubmitStatus}
      onSubmit={login}
    />
  );
}

export default SignIn;
